import React from 'react';

function Footer() {
  return (
    <footer className="tc-footer-style1">
      <div className="container">

        {/* ── Top Section ── */}
        <div className="top-content section-padding">
          <div className="row gx-0">

            {/* Col 1 – Logo + tagline + social */}
            <div className="col-lg-3">
              <div className="info-side">
                <a href="/" className="navbar-brand d-inline-block">
                  <img
                    src="/home1/assets/img/logo.png"
                    alt="SS"
                    className="logo"
                    style={{ width: '100px', height: 'auto', objectFit: 'contain' }}
                  />
                </a>
                <div className="text fsz-15 color-333 lh-3 fw-400 mt-20">
                  We believe that architecture has the power to shape lives and
                  uplift communities. Our philosophy is a passion for innovation,
                  sustainability, and timeless aesthetics.
                </div>
                <div className="foot-social mt-40">
  {/* Facebook */}
  <a
    href="https://www.facebook.com/share/1CxX2Vsq7p/"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Facebook"
  >
    <i className="fab fa-facebook-f"></i>
  </a>

  {/* Instagram */}
  <a
    href="https://www.instagram.com/ss.architects.interiors?igsh=eDNzNndzejR2ZjNj"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Instagram"
  >
    <i className="fab fa-instagram"></i>
  </a>

  {/* Threads */}
  <a
    href="https://www.threads.com/@ss.architects.interiors"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Threads"
  >
    <i className="fa-brands fa-threads"></i>
  </a>

  {/* LinkedIn */}
  <a
    href="https://www.linkedin.com/company/ss-architects-interiors/"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="LinkedIn"
  >
    <i className="fab fa-linkedin-in"></i>
  </a>
</div>
              </div>
            </div>

            {/* Col 2 – Nav links (mirrors Navbar) */}
            <div className="col-lg-2 offset-lg-1">
              <h6 className="mb-20 mt-5 mt-lg-0 fw-600 text-uppercase ls-2 fsz-12">
                Navigation
              </h6>
              <ul className="footer-links">
                <li><a href="/">Home</a></li>
                <li><a href="/innerpages/about">About</a></li>
                <li><a href="/innerpages/services">Services</a></li>
                <li><a href="/innerpages/blog">Blog</a></li>
                <li><a href="/innerpages/portfolio">Portfolio</a></li>
                <li><a href="/innerpages/contact">Contact</a></li>
              </ul>
            </div>

            {/* Col 3 – Services */}
            {/* <div className="col-lg-2">
              <h6 className="mb-20 mt-5 mt-lg-0 fw-600 text-uppercase ls-2 fsz-12">
                Services
              </h6>
              <ul className="footer-links">
                <li><a href="#">3D Visualization</a></li>
                <li><a href="#">Interior Architecture</a></li>
                <li><a href="#">Sustainable Design</a></li>
                <li><a href="#">Urban Planning</a></li>
                <li><a href="#">Landscape Design</a></li>
              </ul>
            </div> */}

            {/* Col 4 – Contact + Newsletter */}
            <div className="col-lg-5 offset-lg-1">
              <h6 className="mb-20 mt-5 mt-lg-0 fw-600 text-uppercase ls-2 fsz-12">
                Get In Touch
              </h6>
              <ul className="footer-links mb-30">
                <li><a>G-67, G Block, South City 1, Sector 41, Gurugram, Haryana 122022</a></li>
                <li><a href="mailto:info.ssarchitectsandinteriors@gmail.com">info.ssarchitectsandinteriors@gmail.com</a></li>
                <li><a href="tel:+91 95998 74844">+91 95998 74844</a></li>
              </ul>

              <h6 className="mb-15 fw-600 text-uppercase ls-2 fsz-12">Newsletter</h6>
              <p className="fsz-13 color-666 mb-15">
                Stay updated with our latest projects &amp; insights.
              </p>
              <div className="d-flex align-items-center gap-2">
                <input
                  type="email"
                  placeholder="Your email"
                  className="form-control rounded-0 border-0 border-bottom fsz-13 bg-transparent"
                />
                <a
                  href="#"
                  className="butn hover-bg-black text-capitalize bg-orange1 rounded-pill text-white flex-shrink-0"
                >
                  <span className="fsz-12">Subscribe</span>
                </a>
              </div>
            </div>

          </div>
        </div>

        {/* ── Bottom Bar ── */}
        <div className="foot">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <p className="fsz-13 color-666 mb-0">
                © {new Date().getFullYear()} SS Architects & Interiors. All Rights Reserved.
              </p>
            </div>
            <div className="col-lg-6">
  <div className="mt-4 mt-lg-0 text-lg-end">
    <p className="fsz-13 color-666 mb-0">
      Designed &amp; Developed by{" "}
      <a
        href="https://digitalconnexions.in/"
        target="_blank"
        rel="noopener noreferrer"
        className="fw-600 text-decoration-none"
      >
        Digital Connexions
      </a>
    </p>
  </div>
            </div>
          </div>
        </div>

      </div>
    </footer>
  );
}

export default Footer;